import {
  RESET_ECHARTSLINE
} from '../mutation-types'

import { meetingTendency, getEquipmentCondition, userLoginTendency } from "@/api/echarts";
const state = {

  datadate: [],
  datacount: [],
  dataaverage: [],
  Chartlist: [],
}

const mutations = {
  [RESET_ECHARTSLINE](state, Chartlist) {

    state.Chartlist = Chartlist
    state.datadate = []
    state.datacount = []
    state.dataaverage = []
    Chartlist.forEach((item) => {
      // state.datadate.push(item.date.split("-")[2]);
      state.datadate.push(item.date.split("-")[1] + '-' + item.date.split("-")[2]);
      state.datacount.push(item.count);
      // state.dataaverage.push(item.average);

      // sessionStorage.setItem("datadate", state.datadate);
      // sessionStorage.setItem("datacount", state.datacount);


    });
  },

}

const actions = {
  //地址
  async meetingTendencytion({ commit, state }, meeting) {


    const res = await userLoginTendency(meeting)
    if (res.code == 200) {

      const Chartlist = res.data.data


      commit(RESET_ECHARTSLINE, Chartlist)
    }
  },
}

export default {
  state,
  mutations,
  actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/echarts.js